import { coachConstants } from '../_constants';
import { coachService } from '../_services';
import { alertActions } from './';

export const coachActions = {
    checkMembership,
    delete: _delete
};

function checkMembership(coachId) {
    return dispatch => {

        coachService.checkMembership(coachId)
        .onSnapshot(snapshot => {
            var subscriptions = {};
            
            dispatch(check(subscriptions));
        }, err => {
            console.log(`Encountered error: ${err}`);
            dispatch(failed(null));
            dispatch(alertActions.error(err));
        });
    };

    function check(subscriptions) { return { type: coachConstants.COACH_SUBSCRIPTION, subscriptions } }
    function failed() { return { type: coachConstants.COACH_SUBSCRIPTION_FAILURE } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    return dispatch => {
        dispatch(request(id));

        coachService.delete(id)
            .then(
                coach => { 
                    dispatch(success(id));
                },
                error => {
                    dispatch(failure(id, error));
                }
            );
    };

    function request(id) { return { type: coachConstants.DELETE_REQUEST, id } }
    function success(id) { return { type: coachConstants.DELETE_SUCCESS, id } }
    function failure(id, error) { return { type: coachConstants.DELETE_FAILURE, id, error } }
}